export enum UserPrivilege {
  AUCTIONEER = "AUCTIONEER",
  BIDDER = "BIDDER",
  SUPER_ADMIN="SUPER_ADMIN"
}
